const updateLoyaltyCard = (html) => {
  const card = document.querySelector('.purchase-process-sidebar .loyalty-card, .cart-module .loyalty-card');
  if (card && html) card.outerHTML = html;
};

const initLoyaltyCard = (card) => {
  if (card.dataset.loyaltyInitialized) return;
  card.dataset.loyaltyInitialized = 'true';

  const currentBar = card.querySelector('.loyalty-card__progress-bar-current');
  const newBar = card.querySelector('.loyalty-card__progress-bar-new');

  const titleMain = card.querySelector('.loyalty-card__title-main');
  const titleDiscount = card.querySelector('.loyalty-card__title-discount');
  const titleApplied = card.querySelector('.loyalty-card__title-applied');

  const textMain = card.querySelector('.loyalty-card__text-main');
  const textDiscount = card.querySelector('.loyalty-card__text-discount');

  const eligibleText = card.querySelector('.loyalty-card__eligible-text');

  const buttonWrapper = card.querySelector('.loyalty-card__button');
  const button = buttonWrapper?.querySelector('.btn');
  const buttonText = button?.querySelector('.btn__text');
  const originalButtonText = buttonText?.innerHTML;
  const { couponCode } = card.dataset;

  const showEligibleState = () => {
    buttonWrapper?.classList.remove('hide');
    titleDiscount?.classList.remove('hide');
    textDiscount?.classList.remove('hide');

    titleMain?.classList.add('hide');
    textMain?.classList.add('hide');

    eligibleText?.classList.remove('hide');
  };

  const showAppliedState = () => {
    titleMain?.classList.add('hide');
    titleDiscount?.classList.add('hide');
    titleApplied?.classList.remove('hide');
  };

  const disableButtonAsApplied = () => {
    if (!button) return;
    button.classList.add('is-disabled', 'is-applied');
    button.disabled = true;
    if (buttonText) {
      buttonText.innerHTML = button.dataset.appliedText || buttonText.innerHTML;
    }
  };

  const resetToEligibleState = () => {
    if (button) {
      button.classList.remove('is-disabled', 'is-applied');
      button.disabled = false;
      if (buttonText && originalButtonText) {
        buttonText.innerHTML = originalButtonText;
      }
    }
    titleApplied?.classList.add('hide');
    showEligibleState();
  };

  const updateCardState = () => {
    const currentWidth = parseFloat(currentBar?.style.width || 0);

    if (card.classList.contains('loyalty-card--applied-state')) {
      showEligibleState();
      showAppliedState();
      disableButtonAsApplied();
      return;
    }

    if (currentWidth >= 100) {
      showEligibleState();
    }
  };

  // Initial state check
  updateCardState();

  // Reset when the discount coupon is removed elsewhere (e.g. promo-code chip)
  if (couponCode) {
    document.addEventListener('loyaltyDiscountRemoved', (event) => {
      if ((event.detail?.code || '').toLowerCase() === couponCode.toLowerCase()) {
        card.classList.remove('loyalty-card--applied-state');
        resetToEligibleState();
      }
    });
  }

  // Observe progress changes
  const observer = new MutationObserver(updateCardState);

  [currentBar, newBar].forEach((bar) => {
    if (!bar) return;

    observer.observe(bar, {
      attributes: true,
      attributeFilter: ['style'],
    });
  });

  // Button interaction
  if (!button) return;

  const applyLoyaltyDiscount = async () => {
    const formData = new FormData();
    formData.append('action', 'applyLoyaltyDiscount');
    formData.append('lang', localData.lang);

    const response = await axios.post(localData.siteURL, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    const cartSummaryEl = document.querySelector('.cart-module__sidebar-cart-summary');
    const ppCartSummaryEl = document.querySelector('.purchase-process-prices');
    if (cartSummaryEl) {
      cartSummaryEl.innerHTML = response.data.data.cart_prices_html;
    }
    if (ppCartSummaryEl) {
      ppCartSummaryEl.innerHTML = response.data.data.cart_prices_html;
    }
    updateLoyaltyCard(response.data.data.loyalty_card_html);
  };

  button.addEventListener('click', async () => {
    if (button.disabled) return;

    button.classList.add('is-loading');

    try {
      await applyLoyaltyDiscount();

      card.classList.add('loyalty-card--applied-state');
      showAppliedState();
      disableButtonAsApplied();
    } catch (err) {
      console.error(err);
    } finally {
      button.classList.remove('is-loading');
    }
  });
};

document.querySelectorAll('.loyalty-card').forEach(initLoyaltyCard);

// Cart/checkout content routinely gets swapped via innerHTML after AJAX
// updates (quantity change, add/remove item, coupon apply/remove), which
// drops any JS wired to the old nodes. Watch for freshly inserted
// .loyalty-card elements anywhere in the page and (re-)initialize them.
const loyaltyCardObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType !== Node.ELEMENT_NODE) return;

      if (node.matches?.('.loyalty-card')) {
        initLoyaltyCard(node);
      }
      node.querySelectorAll?.('.loyalty-card').forEach(initLoyaltyCard);
    });
  });
});

loyaltyCardObserver.observe(document.body, { childList: true, subtree: true });
